const BASE_URL = process.env.REACT_APP_FFUNC_NET;

const request = async (endpoint: string, body: Record<string, any>) => {
  const response = await fetch(`${BASE_URL}/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.error || 'Request failed');
  }

  return data;
};

export const createCheckoutSession = async (body: {
  quantity: number;
  userId: string;
  leagueId: string;
  seasonId: string;
  has2x1: boolean;
}) => {
  return request('createCheckoutSession', body);
};

export const joinClan = async (body: { uid: string; referralCode: string }) => {
  return request('joinClan', body);
};
